import { BlogPostContentType } from 'constants/blog';
import { BLOG_TUDELFT, BLOG_TUDELFT_LIBRARY } from 'constants/images';
import { BlogPost } from 'containers/blog/post/types';

const TUDelftPost: BlogPost = {
  id: 'tudelft',
  title: 'TU Delft',
  subtitle: "The journey of starting a Master's abroad",
  previewImage: BLOG_TUDELFT,
  date: new Date('14 Oct 2020'),
  content: [
    {
      type: BlogPostContentType.TITLE,
      content: 'TU Delft',
    },
    {
      type: BlogPostContentType.SUBTITLE,
      content: "The journey of starting a Master's abroad",
    },
    {
      type: BlogPostContentType.POST_INFO,
      content: '14 Oct 2020 · 5 minute read',
    },
    {
      type: BlogPostContentType.FULL_IMAGE,
      content: BLOG_TUDELFT,
    },
    {
      type: BlogPostContentType.TEXT,
      content:
        "Time flies amazingly fast. It feels like yesterday I was moving to Cluj to start my Bachelor's and today my life already turned the page to a new chapter. Deciding to start a Master's abroad was influenced by multiple factors. The main one was to get myself out of the comfort zone, to not accept the default. It would have been obviously easier to continue studying at my previous uni, but life's not about staying in the same place for too long. At least not for me. Moving to a new culture, with people from all over the globe was a challenge that sounded to good to not take it. So, I took the commitment to make this a reality sometime in September 2019. Hanging out with friends in one particular night and talking about future life plans brought an unexpected amount of motivation to get this started.",
    },
    {
      type: BlogPostContentType.TEXT,
      content:
        "The initial phase was a bit slow in terms of progress. I did not know which country would suit me, which Master's degree to take or whether or not to do this at all. I didn't even know which were the options. Time went by, while I was constantly questioning myself. Until one point in mid-November. I had to take action. Otherwise, nothing would come out of nowhere. I sat down at my desk one afternoon and started a long research, which resulted in a nice and organised spreadsheet with almost all the decent options in Europe.",
    },
    {
      type: BlogPostContentType.TEXT,
      content:
        'Nothing was sweeter than finding out that I had some pretty tight deadlines comming up. Gathered all the requirements and laid out a timetable for each of them. Besides a lot of paperwork and university documents, I had to take the the GRE(Graduate Record Examination) and IELTS tests. The surprise was to find that the only dates available were around mid-December, on two consecutive days. Easier said than done, I had around 5 days to prepare for each, while also doing my normal university stuff and a part time research collaboration. While IELTS was quite easy, GRE seemed way more complicated. As an advice for the 2019 me, I should have definitely started the planning earlier.',
    },
    {
      type: BlogPostContentType.TEXT,
      content:
        'As the Parkinson\'s law states, "Work expands so as to fill the time available for its completion". Although I feel this happening quite often, I had a few days when the exact opposite happened. Somehow, time expanded so as to fit all the work I had to do. I still remember 3 days in December 2019; a Sunday, Monday and a Tuesday. The exact days for the GRE, IELTS and the final pitch for the project at Metro, plus an unexpected university exam. Being in Bucharest on Sunday, taking the exam, then flying home late in the night to take the IELTS the next morning, then jumping straight into crafting a 40 minute presentation, only to deliver it the next day. I\'m still thinking of those days as being some of the most interesting in the last while. Nice things happen when the circumstances force me to do more in less time.',
    },
    {
      type: BlogPostContentType.TEXT,
      content:
        "Having the results from the aforementioned exams and all the paperwork ready, the application process started. I still recall the mainstream process of filling all the custom forms for every university and the late nights trying to figure out how to properly upload the documents. But I guess it's part of the game, so I forced myself to enjoy it, for the greater cause. ",
    },
    {
      type: BlogPostContentType.TEXT,
      content:
        'By the end of January the applications for each university were mostly done, so a long waiting period was ahead, until a few month later. I thought it would be boring to focus only on school and thesis but Covid came to spice up the whole year. ',
    },
    {
      type: BlogPostContentType.TEXT,
      content:
        'Around April the results started to come while I was impatiently waiting to see where would life lead me for the next couple of years. After getting quite a few offers, out of around 16 applications, it was obviously the time to take a decision. Hard moment to be honest. Would the bikes of Netherlands or the cold winters in Finland be more enjoyable? What about daily British accent or northern lights?',
    },
    {
      type: BlogPostContentType.TEXT,
      content:
        'Keeping a balance between the quality of studies, culture, monthly expenses and things to do in the free time, the Netherlands was the best choice I had. ',
    },
    {
      type: BlogPostContentType.SECTION_BREAK,
    },
    {
      type: BlogPostContentType.TEXT,
      content:
        'Thus, the next chapter of my life started as a student at the Technical University of Delft, the oldest and most prestigious technical university in the Netherlands, ranking on the 50th place in the world, according to the QS rankings at that time. This, plus ranking 6th in Europe for Engineering and Technology makes it a quite nice place to get some quality knowledge and experience. Also, my cycling background made the Netherlands a nice place to bike on my way to school.',
    },
    {
      type: BlogPostContentType.NORMAL_IMAGE,
      content:
        'https://images.unsplash.com/photo-1572800597708-8602c67b6d29?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1200&q=80',
    },
    {
      type: BlogPostContentType.TEXT,
      content:
        'By far the hardest thing was to find accommodation. Although the university offered some options, I mailed all the agencies I could find, just to find out that they do not rent to students. After a long decision process, given the ongoing pandemic, I got a pretty decent studio for around double the price you will pay for the same thing in Romania. Yes, things are generally more pricy here than what I was used to at home. Since Delft is a small city, it takes me around 8 minutes to both the university and the city center.',
    },
    {
      type: BlogPostContentType.TEXT,
      content:
        'One thing that I also noticed in the past is the amazing rail system they have, with fast and smooth trains that take you to awesome countryside landscapes, with windmills and endless fields. Although it comes at a higher price, a random train ride once in a while is a really calming thing to have. I love how well connected this region is to a lot of places. 50 minutes to Amsterdam, 15 to Rotterdam, 15 to The Hague, while Paris is 3 hours away.',
    },
    {
      type: BlogPostContentType.NORMAL_IMAGE,
      content: BLOG_TUDELFT_LIBRARY,
    },
    {
      type: BlogPostContentType.TEXT,
      content:
        'During the first month, it was a bit of a struggle to be honest, since I wanted both my last month as a Bloomberg intern and my first uni month to go smoothly. On average, I studied 4 hours and worked 8 per day, with a slight sense of diminishing returns in the last week.\n' +
        'I barely had time to explore the place, but lots of things are different at a first glance. Starting from people and prices to the old buildings in the city center and the perfect biking infrastructure, everything lights up a sense of exploration in me.',
    },
    {
      type: BlogPostContentType.TEXT,
      content:
        'From the study point of view, there is a significant increase in workload, with teachers expecting you to study around 40 hours per week. The infrastructure, though, is way better compared to what I experienced before. Every course is prerecorded, so you can watch it at 1.5x speed, exams and assignments are handled through a common platform and lecturers and teaching assistants are easy to reach through an internal app similar to Slack. Everyone here expects you to be proactive and to have a desire to do research by yourself, which is quite nice. Teachers are generally more open minded and open to suggestions and debates.',
    },
    {
      type: BlogPostContentType.SECTION_BREAK,
    },
    {
      type: BlogPostContentType.TEXT,
      content:
        "I wouldn't say it was very hard to get here after all, although I had moments of doubt. It was definitely an interesting experience so far and I always think that the best is yet to come. I'm constantly amazed by how open the teachers are, how nice people are in general and how they decide to bike despite the cold and sometimes rainy weather. I'm still in the process of further discovering this place and I'm sure it has way more to offer.",
    },
  ],
};

export default TUDelftPost;
